<template>
    <section>
        <main class="main-wrapper" @click="hideSearchResults($event.target)">
            <h1 class="heading-xl">Card Comparison</h1>
            <p class="subheading">Use our card comparison tool to review up to four credit cards provided by our partners.</p>
            <search-bar :cards="cards"></search-bar>
            <div class="advertiser-disclosure">
                <a href="#" :target="'#advertiser-disclosure-comparison'" @click.prevent="openModal($event.target.target)">Advertiser Disclosure</a>
            </div>
            <div class="compare-cards">
                <more-than-one-card v-if="IsCards" :cards="updatedCards" :page-request-id="pageRequestId" @card-removed="removeCardFromCompare" :isSticky="isSticky"></more-than-one-card>
                <one-card v-if="IsOneCard" :cards="updatedCards" @add-saved-cards="addCardToCompare" @card-removed="removeCardFromCompare" :isSticky="isSticky"></one-card>
                <no-cards v-if="!IsCards && !IsOneCard" @add-saved-cards="addCardToCompare"></no-cards>
            </div>
            <div class="general-disclaimer">
                <p>General Disclaimer: See the online credit card application for details about terms and conditions. We make every effort to maintain accurate information. However, all credit card information is presented without warranty. To confirm terms and conditions, click the "Apply Now" button and review info on the secure credit card terms page.</p>
            </div>
        </main>
    </section>
</template>
<style src="../../shared/sass/coca-main.scss" lang="scss"></style>
<style src="../../shared/sass/saved-cards/app.scss" lang="scss"></style>
<script>
    import PageService from '../../shared/services/page-service';
    import NoCards from './NoCards.vue';
    import MoreThanOneCard from './MoreThanOneCard.vue';
    import OneCard from './OneCard.vue';
    import SearchBar from './SearchBar.vue';

    import MetaTags from '../../shared/mixins/meta-tags';
    import SavedCompareCardsMixin from '../../shared/mixins/saved-compare-cards';
    import CardService from '../../shared/services/card-service';

    export default {
        name: 'app',
        props: {
            pageVariation: {
                type: Object,
                required: false
            }
        },
        data: function () {
            return {
                pageData: null,
                cards: [],
                updatedCards: [],
            };
        },
        watch: {
            // whenever cards array is updated, this function will run to reorder and add "best" labels accordingly
            cards: function (newCards) {
                if (newCards && newCards.length > 0) {
                    //for adobe analytics tracking
                    var trackData = { creditCard_data: [] };
                    var category = this.$analyticsService.getCategoryName();
                    newCards.forEach((card, index) => {
                        var trackCard = {
                            card_id: card.cardId,
                            card_page: location.href,
                            card_position: (++index),
                            card_section: category,
                            category: category,
                        }
                        trackData.creditCard_data.push(trackCard);
                    });
                    this.$analyticsService.trackCTA(trackData, "Credit Card Impression");

                    //for updating "best" labels
                    CardService.getSavedCards(newCards).then((res) => {
                        if (res && res.data) {
                            this.updatedCards = res.data;
                        }
                        else {
                            console.log("There was an error reordering cards.");
                        }
                    });
                }
            },
        },
        mixins: [MetaTags, SavedCompareCardsMixin],
        computed: {
            pageRequestId: function () {
                return pageRequestId || "";
            },
            IsCards: function () {
                return this.cards != null && this.cards && this.cards.length > 1;
            },
            IsOneCard: function () {
                return this.cards != null && this.cards && this.cards.length == 1;
            },
        },
        methods: {
            getUpdatedCards: function (cardList) {
                let updatedCards = localStorage.getItem('cardItems') ? JSON.parse(localStorage.getItem('cardItems')) : [];

                cardList.forEach((card, index) => {
                    var cardIndex = updatedCards.findIndex(f => f.CardId == card.cardId);
                    if (cardIndex == -1) {
                        var cardDetails = {
                            id: card.legacyId,
                            CardId: card.cardId,
                            CardName: card.name,
                            Highlight: {
                                Label: card.editorialContent.highlights[0].label,
                                Text: card.editorialContent.highlights[0].text
                            },
                            RedirectLink: card.redirectLink,
                            ImageUrl: card.imageUrl,
                            DetailsUrl: card.detailsUrl,
                            IsRateFees: card.issuer.ratesAndFeesIndicator,
                            IsRateFeesTermsApply: card.issuer.ratesAndFeesTermsApplyIndicator,
                            BankTermsUrl: card.bankTermsUrl
                        }
                        updatedCards.push(cardDetails);
                    }
                });
                return updatedCards;
            },
            addCardToCompare: function (card) {
                //add this cards array to vue state so it will be available in another component as well for data binding
                var cardArray = [];
                cardArray.push(card);

                if (cardArray) {
                    var sessionCards = this.getUpdatedCards(cardArray);
                    if (sessionCards.length > 0) {
                        localStorage.setItem('cardItems', JSON.stringify(sessionCards));
                        this.moreThanOneCards(sessionCards);
                    }
                }
            },
            removeCardFromCompare: function(card) {
                var cardIdValue = card.cardId;
                var savedCreditCards = localStorage.getItem('cardItems') ? JSON.parse(localStorage.getItem('cardItems')) : [];
                var indexOfSession = savedCreditCards.findIndex(f => f.cardId == cardIdValue);
                if (indexOfSession != -1) {
                    savedCreditCards.splice(indexOfSession, 1);
                    localStorage.setItem('cardItems', JSON.stringify(savedCreditCards));
                }
                this.cards = savedCreditCards;
            },
            closeModal: function(modal) {
                const backdrop = document.querySelector('.modal-backdrop.fade.show');
                modal.setAttribute('aria-hidden', 'true');
                backdrop.classList.remove('show');
                setTimeout(() => {
                modal.classList.remove('show');
                if (!document.querySelector('.modal.show')) {
                    document.body.classList.remove('modal-open');
                }
                });
                setTimeout(() => {
                modal.style.display = 'none';
                    backdrop.remove();
                }, 500);
            },
            hideSearchResults: function(el) {
                var searchInput = document.querySelector('#card-search');
                var searchResults = document.querySelector('.results-container')
                
                if (el != searchInput && el != searchResults) {
                    searchResults.style.display = 'none';
                } else {
                    searchResults.style.display = 'block';
                }
            },
            isSticky: function(el) {
                let stickyElementStyle = null;
                let stickyElementTop = 0;

                if (!stickyElementStyle) {
                    stickyElementStyle = window.getComputedStyle(el);
                    stickyElementTop = parseInt(stickyElementStyle.top, 0);
                }

                const currentTop = el.getBoundingClientRect().top;
                el.classList.toggle('pinned', currentTop <= stickyElementTop);
            }
        },
        components: {
            NoCards,
            MoreThanOneCard,
            OneCard,
            SearchBar,
        },
        created: function () {
            PageService.getPageData('saved-credit-cards').then((res) => {
                if (res && res.data) {
                    this.pageData = res.data;
                }
                else {
                    console.log("PAGE DOES NOT EXIST, SO ADD IT TO THE ADMIN");
                }
            });
            if (this.pageVariation.id !== null) {
                let pageVariationCards = this.pageVariation.sections.flatMap(section => section.itemCollection.flatMap(itemArray => itemArray.items || []))
                    .filter(item => item.itemType === "card" && item.card)
                    .map(item => item.card)
                    .slice(0, 4);
                
                if (pageVariationCards && pageVariationCards.length > 0) {
                    localStorage.setItem('cardItems', JSON.stringify(pageVariationCards));
                    this.moreThanOneCards(pageVariationCards);
                }
            } else {
                let savedCards = localStorage.getItem('cardItems') ? JSON.parse(localStorage.getItem('cardItems')) : [];
                if (savedCards && savedCards.length > 0) {
                    this.moreThanOneCards(savedCards);
                }
            }
        },
        mounted: function () {
            //for adobe analytics tracking
            this.$analyticsService.pageView();
            document.querySelectorAll('[data-dismiss=modal]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    const modal = document.querySelector('.modal.show');
                    if (modal) {
                        this.closeModal(modal);
                    }
                });
            });
        },
        updated: function() {
            // syncing the scrolling between both grid containers
            const gridContainers = document.querySelectorAll('.grid-container');
            gridContainers.forEach((el) => {
                el.addEventListener('scroll', function() {
                    gridContainers.forEach((el) => {
                        el.scrollLeft = this.scrollLeft;
                    });
                })
            });
        },
    };
</script>
